module.exports = __webpack_public_path__ + "img/home_hnews7_2.e9e16804.png";